import React from "react";
import AuthNotSupported from "./pages/AuthNotSupported";
import Landing from "./pages/Landing";
import Home from "./pages/Home";

const routes = ({page, basename, history}) => {
    return [
        {
            route: "/landing",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/home",
            component: (
                <Home history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth-not-supported",
            component: (
                <AuthNotSupported history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
    ];
};

export default routes;
